var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L9.65889 10.5491C8.86532 9.88777 8.46855 9.55713 8.1833 9.1518C7.93055 8.79266 7.74286 8.39192 7.62876 7.96785C7.5 7.48924 7.5 6.97274 7.5 5.93975V2.5M15 15L20.3411 10.5491C21.1346 9.88777 21.5315 9.55713 21.8167 9.1518C22.0695 8.79266 22.2571 8.39192 22.3712 7.96785C22.5 7.48924 22.5 6.97274 22.5 5.93975V2.5M15 15L9.65889 19.4509C8.86532 20.1123 8.46855 20.4429 8.1833 20.8483C7.93055 21.2074 7.74286 21.6081 7.62876 22.0321C7.5 22.5107 7.5 23.0272 7.5 24.0602V27.5M15 15L20.3411 19.4509C21.1346 20.1123 21.5315 20.4429 21.8167 20.8483C22.0695 21.2074 22.2571 21.6081 22.3712 22.0321C22.5 22.5107 22.5 23.0272 22.5 24.0602V27.5M5 2.5H25M5 27.5H25",
    stroke: "currentColor",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/Hourglass.6de117e90bd05628926fce793f8bc21b.svg";
export { ForwardRef as ReactComponent };